var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { CommentRepository, CommentReferenceType } from '@amityco/js-sdk';
import { LIKE_REACTION_KEY } from '../../../constants';
import customizableComponent from '../../../core/hocs/customization';
import usePost from '../../../social/hooks/usePost';
import UIEngagementBar from './UIEngagementBar';
import { useActionEvents } from '../../../core/providers/ActionProvider';
const EngagementBar = ({ postId, readonly, handleCopyCommentPath, isHighlighted, showComments, isCommentingEnabled, }) => {
    const [isComposeBarDisplayed, setComposeBarDisplayed] = useState(false);
    const toggleComposeBar = () => setComposeBarDisplayed((prevValue) => !prevValue);
    const actionEvents = useActionEvents();
    const hideComposeBar = () => setComposeBarDisplayed(false);
    const { post } = usePost(postId);
    const { commentsCount, reactions = {}, targetId, targetType } = post;
    const handleAddComment = (commentText, mentionees, metadata) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        yield CommentRepository.createTextComment({
            referenceType: CommentReferenceType.Post,
            referenceId: postId,
            text: commentText,
            mentionees,
            metadata,
        });
        (_a = actionEvents.onCommentCreate) === null || _a === void 0 ? void 0 : _a.call(actionEvents, {
            isReply: false,
            isDisabled: !isCommentingEnabled,
        });
        hideComposeBar();
    });
    return (React.createElement(UIEngagementBar, { postId: post.postId, targetId: targetId, targetType: targetType, isHighlighted: isHighlighted, isCommentingEnabled: isCommentingEnabled, totalLikes: reactions[LIKE_REACTION_KEY], totalComments: commentsCount, readonly: readonly, showComments: showComments, isComposeBarDisplayed: isComposeBarDisplayed, handleAddComment: handleAddComment, onClickComment: toggleComposeBar, handleCopyCommentPath: handleCopyCommentPath }));
};
EngagementBar.propTypes = {
    postId: PropTypes.string.isRequired,
    readonly: PropTypes.bool,
    handleCopyCommentPath: PropTypes.func,
    isHighlighted: PropTypes.bool,
    showComments: PropTypes.bool,
    isCommentingEnabled: PropTypes.bool,
};
EngagementBar.defaultProps = {
    readonly: false,
};
export { UIEngagementBar };
export default memo(customizableComponent('EngagementBar', EngagementBar));
//# sourceMappingURL=index.js.map